import { DataTable, DataTableColumnDef } from "@shared/EDS/components/DataTable/DataTable";
import { KapiNotification } from "@opstel/query/models/kapiNotification.ts";
import { DATETIME_FORMAT_NO_SECONDS } from "@shared/common/utils/luxonHelpers.ts";

const columns: DataTableColumnDef<KapiNotification>[] = [
  {
    id: "message",
    header: "Toelichting",
    accessorKey: "message",
    enableSorting: true,
  },
  {
    id: "trainNumber",
    header: "Treinnummer",
    accessorKey: "trainInfo.trainNumber",
    cell: ({ row }) => `${row.original.trainInfo?.trainNumber ?? ""}`,
    enableSorting: true,
  },
  {
    id: "day",
    header: "Dag",
    accessorKey: "trainInfo.timeInfo",
    cell: ({ row }) =>
      `${row.original.trainInfo?.timeInfo.toFormat(DATETIME_FORMAT_NO_SECONDS) ?? ""}`,
    enableSorting: true,
  },
];

interface NotificationListProps {
  notifications: KapiNotification[] | null;
}

export function NotificationList({
  notifications,
}: Readonly<NotificationListProps>): React.JSX.Element {
  return (
    <DataTable
      columns={columns}
      data={notifications ?? []}
      defaultSort={[{ id: "trainNumber", desc: false }]}
      options={{
        loadingMessage: "Plannen worden opgehaald",
      }}
    />
  );
}
